export const I80_TEST_HOSTNAME = "i80.testportal.truckit.com";
export const I80_TEST_PORTAL_DATA = {
    parentCompanyId: 2353,
    parentCompanyUUID: "ac5add85-d318-435a-bb36-0551b15f3eb0",
    tabTitle: "I80 CONCRETE",
    customerRole: "I80 Customer",
};
